export default class Contact{
	constructor(){
		if(document.body.classList.contains("contact")){
			this.initialize();
		}
	}
	initialize(){
		const form = document.querySelector("form.contact__form");
		if(!form) return;

		const pulldowns = document.querySelectorAll(".contact__form__part__input__select");
		pulldowns.forEach(pulldown=>{
			const select = pulldown.querySelector(".contact__form__part__input__select__pulldown");
			const label = pulldown.querySelector(".contact__form__part__input__select__label");
			select.addEventListener("change", ()=>{
				label.classList.add("selected");
				label.innerHTML = select.querySelector("option[value='"+select.value+"']").innerHTML;
			}, false);
		});

		const formsection = document.querySelector("#mailform");
		const buttons = form.querySelector('.contact__form__buttons');
		const confirmButton = form.querySelector('.contact__form__buttons__confirm');
		const sendButton = form.querySelector('.contact__form__buttons__send');
		const sendButtonLabel = sendButton.querySelector('.hoverRoll__text > span');
		const backButton = form.querySelector('.contact__form__buttons__back');
		const messages = form.querySelectorAll('.contact__form__messages > div');
		const erroritems = form.querySelectorAll('.contact__form__messages__errors ul li');
		const confirmtext = form.querySelector('.contact__form__confirmtext');
		const sendPath = "/send/";
		let isConfirmed = false;
		const isWedding = document.body.classList.contains("wedding");

		const typeselect = form.querySelectorAll("input[type='radio'][name='type']");
		const detachable_companyname = form.querySelector("#companyname");
		const detachable_plan = form.querySelector("#planned_numbers");
		const detachable_visit = form.querySelector("#visit_schedule");
		let currenttype = "restaurant";
		typeselect.forEach(radio=>{
			radio.addEventListener("change", ()=>{
				if(radio.checked){
					if(currenttype != radio.value){
						currenttype = radio.value;
						form.setAttribute("data-currenttype", currenttype);
						if(currenttype == "party" || currenttype == "restaurant"){
							detachable_companyname.style.opacity = 0;
							detachable_companyname.style.display = "flex";
							requestAnimationFrame(()=>{requestAnimationFrame(()=>{
								detachable_companyname.style.opacity = 1;
							})})
						}else{
							detachable_companyname.style.display = "none";
						}
						if(currenttype == "wedding" || currenttype == "request"){
							detachable_plan.style.opacity = 0;
							detachable_plan.style.display = "block";
							requestAnimationFrame(()=>{requestAnimationFrame(()=>{
								detachable_plan.style.opacity = 1;
							})})
						}else{
							detachable_plan.style.display = "none";
						}
						if(currenttype == "visit"){
							detachable_visit.style.opacity = 0;
							detachable_visit.style.display = "block";
							requestAnimationFrame(()=>{requestAnimationFrame(()=>{
								detachable_visit.style.opacity = 1;
							})})
						}else{
							detachable_visit.style.display = "none";
						}
					}
				}
			}, false);
		});

		confirmButton.addEventListener('click',  (e) => {
			e.preventDefault();

			messages.forEach((msg) =>{
				msg.classList.remove('show', 'fadein');
			});
			erroritems.forEach((msg) =>{
				msg.classList.remove('show');
			});

			const validationResult = validate();
			if(validationResult===true){
				form.classList.remove("appear");
				form.classList.add("transitioning");
				form.classList.add("confirmation");
				requestAnimationFrame(()=>{requestAnimationFrame(()=>{
					form.classList.add("appear");
					setTimeout(()=>{
						form.classList.remove("transitioning");
						form.classList.remove("appear");
					}, 1000);
				})});

				const textarea_input = form.querySelectorAll(".contact__form__part__input--textarea");
				textarea_input.forEach(tai=>{
					const textarea = tai.querySelector("textarea");
					const confirmation = tai.querySelector(".contact__form__part__input--textarea__confirmation");
					if(textarea.value){
						confirmation.innerText = textarea.value;
						confirmation.classList.remove("blank");
					}else{
						confirmation.innerText = textarea.getAttribute("placeholder");
						confirmation.classList.add("blank");
					}
				});

				if(window.smoothscroller){
					gsap.to(window.smoothscroller, {
						scrollTop: Math.min(
							ScrollTrigger.maxScroll(window),
							window.smoothscroller.offset(formsection, "top "+(isWedding ? window.rpx(window.currentContext=="pc" ? 119 : 129) : 0)+"px")
						),
						ease: "expo.out",
						duration: 0.75
					});
				}else{
					gsap.to(window, 0.5, {
						scrollTo: {
							y:formsection,
							autoKill:false,
							offsetY: (isWedding ? window.rpx(window.currentContext=="pc" ? 119 : 129) : 0)
						},
						ease: "expo.out"
					});
				}

				const inputs = form.querySelectorAll("input,textarea,select");
				inputs.forEach(item=>{
					item.setAttribute("tabindex", -1);
					item.setAttribute("readonly", true);
				})

			}else{
				formInvalid(validationResult);
			}
		}, false);
		backButton.addEventListener('click',  (e) => {
			e.preventDefault();

			messages.forEach((msg) =>{
				msg.classList.remove('show', 'fadein');
			});
			erroritems.forEach((msg) =>{
				msg.classList.remove('show');
			});

			const inputs = form.querySelectorAll("input,textarea,select");
			inputs.forEach(item=>{
				item.removeAttribute("tabindex");
				item.removeAttribute("readonly");
			});

			form.classList.remove("appear");
			form.classList.add("transitioning");
			form.classList.remove("confirmation");
			requestAnimationFrame(()=>{requestAnimationFrame(()=>{
				form.classList.add("appear");
				setTimeout(()=>{
					form.classList.remove("transitioning");
					form.classList.remove("appear");
				}, 1000);
			})});

			if(window.smoothscroller){
				gsap.to(window.smoothscroller, {
					scrollTop: Math.min(
						ScrollTrigger.maxScroll(window),
						window.smoothscroller.offset(formsection, "top "+(isWedding ? window.rpx(window.currentContext=="pc" ? 119 : 129) : 0)+"px")
					),
					ease: "expo.out",
					duration: 0.75
				});
			}else{
				gsap.to(window, 0.5, {
					scrollTo: {
						y:formsection,
						autoKill:false,
						offsetY: (isWedding ? window.rpx(window.currentContext=="pc" ? 119 : 129) : 0)
					},
					ease: "expo.out"
				});
			}
		}, false)
		sendButton.addEventListener('click',  (e) => {
			e.preventDefault();

			const XHR = new XMLHttpRequest();
			const formData = new FormData(form);

			messages.forEach((msg) =>{
				msg.classList.remove('show', 'fadein');
			});
			erroritems.forEach((msg) =>{
				msg.classList.remove('show');
			});

			sendButton.classList.add('processing');
			sendButtonLabel.innerText = "送信中...";
			backButton.classList.add('disabled');

			XHR.addEventListener('load', (res) => {
				if(res.target.readyState == 4 && res.target.status == 200){
					const response = res.target?.response;
					if(response){
						if(response.status){
							if(response.status == 'ok'){
								formDone();
							}else{
								formError("error when sending", res)
							}
						}else{
							formError("status has not set", res)
						}
					}else{
						formError("empty response", res)
					}
				}else{
					formError("can not catch", res);
				}
			});
			XHR.addEventListener('error', (res) => {
				formError("can not send", res);
			});
			XHR.open('POST', sendPath, true);
			XHR.responseType = 'json';
			setTimeout(()=>{
				XHR.send(formData);	
			}, 750);
		}, false);

		function validate(){
			const bodyInput = form.querySelector("#form_message[data-required]");
			const nameInput = form.querySelector("#form_name01[data-required]");
			const kanaInput = form.querySelector("#form_kana01[data-required]");
			const mailInput = form.querySelector("#form_email[data-required]");
			const telInput = form.querySelector("#form_tel[data-required]");
			const agreeInput = form.querySelector("#form_agree[data-required]");
			const visitorsInput = form.querySelector("#form_num_visitors[data-required]");
			let result = [];

			if(bodyInput){
				if(!bodyInput.value){
					result.push("nobody");
				}
			}
			if(nameInput){
				if(!nameInput.value){
					result.push("noname");
				}
			}
			if(kanaInput){
				if(!kanaInput.value){
					result.push("nokana");
				}
			}
			if(mailInput){
				if(!mailInput.value){
					result.push("nomail");
				}else{
					const regex = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
					if(!regex.test(mailInput.value)){
						result.push("mailinvalid");
					}
				}
			}
			if(telInput){
				if(!telInput.value){
					result.push("notel");
				}
			}
			if(agreeInput){
				if(!agreeInput.checked){
					result.push("noagree");
				}
			}
			if(visitorsInput){
				if(!visitorsInput.value){
					result.push("novisitors");
				}
			}

			if(result.length == 0){
				result = true;
			}

			return result;
		}
		function formError(msg, res){
			// console.log(msg);
			// console.log(res);
			form.querySelector('.contact__form__messages__failed').classList.add('show');
			requestAnimationFrame(()=>{requestAnimationFrame(()=>{
				form.querySelector('.contact__form__messages__failed').classList.add('fadein');
			})});
			buttons.remove();
		}
		function formInvalid(errors){
			form.querySelector('.contact__form__messages__errors').classList.add('show');
			requestAnimationFrame(()=>{requestAnimationFrame(()=>{
				form.querySelector('.contact__form__messages__errors').classList.add('fadein');
			})});
			for(var i=0; i<errors.length; i++){
				form.querySelector('li.'+errors[i]).classList.add('show');
			}
			sendButton.classList.remove('processing');
		}
		function formDone(){
			form.querySelector('.contact__form__messages__success').classList.add('show');
			requestAnimationFrame(()=>{requestAnimationFrame(()=>{
				form.querySelector('.contact__form__messages__success').classList.add('fadein');
			})});
			buttons.remove();
		}

		if(location.hash && !document.body.classList.contains("wedding")){
			const type = location.hash.substring(1);
			if([ "restaurant", "party", "other", "wedding", "request", "visit" ].includes(type)){
				typeselect.forEach(radio=>{
					if(radio.value == type){
						radio.checked = true;
					}else{
						radio.checked = false;
					}
					radio.dispatchEvent(new Event('change'));
				});
				window.addEventListener("siteready", ()=>{
					if(window.smoothscroller){
						gsap.to(window.smoothscroller, {
							scrollTop: Math.min(
								ScrollTrigger.maxScroll(window),
								window.smoothscroller.offset(formsection, "top "+(isWedding ? window.rpx(window.currentContext=="pc" ? 119 : 129) : 0)+"px")
							),
							ease: "expo.out",
							duration: 0
						});
					}else{
						gsap.to(window, 0, {
							scrollTo: {
								y:formsection,
								autoKill:false,
								offsetY: (isWedding ? window.rpx(window.currentContext=="pc" ? 119 : 129) : 0)
							},
							ease: "expo.out"
						});
					}
				});
			}
		}

	}
}